import SectionHeading from './SectionHeading';

const steps = [
  { no: '01', title: '材料初审', desc: '核对材料完整度与来源，剔除无法追溯的转述内容。' },
  { no: '02', title: '交叉比对', desc: '将录音时间点、转账时间、合同条款逐项比对，寻找相互印证点。' },
  { no: '03', title: '当事方回应', desc: '通过公开渠道联系当事方，给予不少于 48 小时的回应时间。' },
  { no: '04', title: '标注发布', desc: '按核实结果标注"已核实 / 待回应 / 审核中"，并保留更新记录。' },
];

export default function ProcessSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="How We Verify"
          title="一条爆料是如何被核实的"
          desc="从收到材料到正式发布，每条内容都会走过同样四个环节，尽量把主观判断降到最低。"
        />
        <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <li key={step.no} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="font-heading text-3xl font-black text-accent-500">{step.no}</span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}